<template>
  <div>
    <div>

      <div class="layout-breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item href="#">系统管理</Breadcrumb-item>
          <Breadcrumb-item href="#">管理员列表</Breadcrumb-item>
        </Breadcrumb>
      </div>

      <div class="layout-content">

        <div class="layout-content-main">

          <div class="method-wrapper">
           <template>
              <Input v-model="key" placeholder="用户名" style="width: 300px"></Input>
          </template>
            
            <Button type="ghost" class="mRight mLeft" @click="showKeyList()" >查询</Button>
            <Button @click.native="createnodemodel = true" type="success" class="mRight">新增</Button>
            <Button type="warning" class="mRight">批量删除</Button>
          </div>

          <div class="clearfix"></div>

          <div class="table-wrapper">
            <!-- <Table  border :columns="columns4" :data="nodes"></Table> -->
            <Table style="min-width: 700px" border :columns="columns7" :data="pagerData.data"></Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <!-- <Page :total="this.total" :current="1" @on-change="changePage"></Page> -->
                     <Page :total="pagerData.page.totalCount" @on-change="onChange"  show-elevator show-total></Page>
                </div>
            </div>
          </div>

        </div>
      </div>


    </div>


    <Modal
      v-model="createnodemodel"
      title="新增"
      @on-ok="addList">
     <!--  <i-form :label-width="60">
        <Form-item label="数量">
          <Input-number :min="1" v-model="nodeNumber"></Input-number>
        </Form-item>

        <Form-item label="类型">
          <Select v-model="selnodeType">
            <Option v-for="item in nodetypes" :value="item.id" :key="item">{{ item.name }}</Option>
          </Select>
        </Form-item>
      </i-form> -->
       <i-form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
          <FormItem label="用户名" prop="name">
              <Input v-model="formValidate.name" placeholder="用户名"></Input>
          </FormItem>
          <FormItem label="邮箱" prop="mail">
              <Input v-model="formValidate.mail" placeholder="邮箱"></Input>
          </FormItem>
          <FormItem label="电话" prop="phone">
              <Input v-model="formValidate.phone" placeholder="电话"></Input>
          </FormItem>
          <FormItem label="状态" prop="state">
              <RadioGroup v-model="formValidate.state">
                  <Radio label="正常">正常</Radio>
                  <Radio label="禁用">禁用</Radio>
              </RadioGroup>
          </FormItem>
          <FormItem label="创建时间">
              <Row>
                  <Col span="11">
                      <FormItem prop="date">
                          <DatePicker type="date" placeholder="Select date" v-model="formValidate.date"></DatePicker>
                      </FormItem>
                  </Col>
                  <Col span="2" style="text-align: center">-</Col>
                  <Col span="11">
                      <FormItem prop="time">
                          <TimePicker type="time" placeholder="Select time" v-model="formValidate.time"></TimePicker>
                      </FormItem>
                  </Col>
              </Row>
          </FormItem>
          
          <FormItem>
              <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
              <Button type="ghost" @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
          </FormItem>
      </i-form>
    </Modal>


    <!-- <Modal
      v-model="editNodeModel"
      title="编辑节点"
      @on-ok="editNodeok">
      <i-form :label-width="60">
        <Form-item label="deui">
          <Input v-model="selNodetoEdit.deui" disabled></Input>
        </Form-item>
        <Form-item label="类型">
          <Select v-model="selNodetoEdit.type">
            <Option v-for="item in nodetypes" :value="item.id" :key="item">{{ item.name }}</Option>
          </Select>
        </Form-item>
      </i-form>
    </Modal> -->


  </div>
</template>
<style scoped lang="scss">
  .table-wrapper {
    overflow: scroll;
  }

  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }
</style>
<script>
  import api from '../../api/apinew'
  import axios from 'axios'
  import Qs from 'qs'
  export default{
    data(){
      return {
        key:'',
        pagerData:{  
           data:[],  
           page:{  
              //分页数  
               // arrPageSize:[10,20,30,40],  
               //分页大小  
               // pagesize:10,  
               //总分页数  
               pageCount:1,  
               //当前页面  
               pageCurrent:1,  
               //总数  
               totalCount:0  
           }  

        },
        listdata:[],
        columns7: [
            {
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {   
                title: 'ID',
                type: 'index',
                width: 60,
                align: 'center'
            },
            {
                title: '用户名',
                key: 'username',
                align: 'center'
            },
            {
                title: '邮箱',
                key: 'email',
                align: 'center'
            },
            {
                title: '电话',
                key: 'phone',
                align: 'center'
            },
            {
                title: '状态',
                key: 'state',
                align: 'center'
            },
            {
                title: '创建时间',
                key: 'creatTime',
                align: 'center'
            },
            {
                title: '操作',
                key: 'action',
                width: 150,
                align: 'center',
                render: (h, params) => {
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    this.show(params.index)
                                }
                            }
                        }, '修改'),
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            on: {
                                click: () => {
                                    this.remove(params.index)
                                }
                            }
                        }, '删除')
                    ]);
                }
            }
        ],
        // lists: this.mockTable(),
        createnodemodel: false,
        nodetypes: [],
        selnodeType: '',
        nodeNumber: 1,
        editNodeModel: false,
        selNodetoEdit: {},
        formValidate: {
            name: '',
            mail: '',
            phone:'',
            date: '',
            time: '',
            state: ''
        },
        ruleValidate: {
            name: [
                { required: true, message: '用户名不能为空', trigger: 'blur' }
            ],
            mail: [
                { required: true, message: '邮箱不能为空', trigger: 'blur' },
                { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
            ],
            phone: [
                { required: true, message: '电话不能为空', trigger: 'blur' },
                { type: 'number', message: '电话格式不正确', trigger: 'blur' }
            ],
            state: [
                { required: true, message: '状态不能为空', trigger: 'change' }
            ],
            date: [
                { required: true, type: 'date', message: '请选择日期', trigger: 'change' }
            ],
            time: [
                { required: true, type: 'string', message: '请选择时间', trigger: 'change' }
            ]
      }
      
      }
    },
    created:function(){  
      // axios.post("http://localhost:8088/Web/List",  
      //     {"abc":"def"},  
      //     {headers: {  
      //             'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'  
      //         }}  
      //     )  
      // .then(res=>{  
          //console.log(JSON.stringify(res.data));
        var   lists = [
                    {
                        username: '张三',
                        email:'111@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-1-29'
                    },
                    {
                        username: '李四',
                        email:'222@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-11-29'
                    },
                    {
                        username: '王二麻子',
                        email:'331@qq.com',
                        phone:'15200008888',
                        state: '正常',
                        creatTime: '2018-08-29'
                    },
                    {
                        username: '张三',
                        email:'111@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-1-29'
                    },
                    {
                        username: '李四',
                        email:'222@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-11-29'
                    },
                    {
                        username: '王二麻子',
                        email:'331@qq.com',
                        phone:'15200008888',
                        state: '正常',
                        creatTime: '2018-08-29'
                    },
                    {
                        username: '张三',
                        email:'111@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-1-29'
                    },
                    {
                        username: '李四',
                        email:'222@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-11-29'
                    },
                    {
                        username: '王二麻子',
                        email:'331@qq.com',
                        phone:'15200008888',
                        state: '正常',
                        creatTime: '2018-08-29'
                    },
                    {
                        username: '张三',
                        email:'111@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-1-29'
                    },
                    {
                        username: '李四',
                        email:'222@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-11-29'
                    },
                    {
                        username: '王二麻子',
                        email:'331@qq.com',
                        phone:'15200008888',
                        state: '正常',
                        creatTime: '2018-08-29'
                    },
                    {
                        username: '张三',
                        email:'111@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-1-29'
                    },
                    {
                        username: '李四',
                        email:'222@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-11-29'
                    },
                    {
                        username: '王二麻子',
                        email:'331@qq.com',
                        phone:'15200008888',
                        state: '正常',
                        creatTime: '2018-08-29'
                    },
                    {
                        username: '李四',
                        email:'222@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-11-29'
                    },
                    {
                        username: '王二麻子',
                        email:'331@qq.com',
                        phone:'15200008888',
                        state: '正常',
                        creatTime: '2018-08-29'
                    }
                 ];
  
          var totalNum = 0;  
          for(var i = 0; i < lists.length; i++){  
              //console.log("res.data[i] is " + i + "\n " + JSON.stringify(res.data[i]));  
              var object = eval(lists[i]);  
              object.index = i+1;  
              totalNum ++;  
              // console.log("i is " + i + "\n " + JSON.stringify(object)); 
              // console.log(this.listdata) 
              this.listdata.push(object);  
              if(i<10){   //初始化获取数据的过程中，将前10个默认加入分页data  
                  this.pagerData.data.push(object);  
              }  
          }  
          this.pagerData.page.totalCount = totalNum;  
      // });  
      // this.loading = false;  
  },
  methods: {
      // 搜索关键词
      showKeyList(){
          console.log(this.key);
          if(this.key == ''){
               this.$Message.error('查询关键词不能为空!');
          }else{
               console.log('通过关键词获取列表')
            // axios.post('http://10.25.53.97:9080/web/sys/user/list', {
            //   "page": 1,
            //   "limit": 10,
            //   "username": this.key
            // }, {
            // headers: {
            //   "date": "Sat, 28 Apr 2018 08:01:13 GMT",
            //   "access-control-allow-credentials": "true",
            //   "server": "Apache-Coyote/1.1",
            //   "content-length": "34",
            //   "content-type": null,
            //   'token':'f526f690bc3068d21ec482d1a0510e39'
            // }, transformRequest: [
            //     function (data) {
            //       return Qs.stringify(data);
            //     }],
            // }).then(
            //   (resp) => {
            //     console.log(resp.data)
            //     console.log(resp.data.code)
            //     if (resp.data.code == 200) {
            //       sessionStorage.setItem('smartkitusername', resp.data.result.username);
            //       sessionStorage.setItem('accesstoken', resp.data.result.token);
            // 展示关键词列表
            //       console.log('200');
                 this.pagerData.data = [];   // 清空列表
                 this.pagerData.data = [     // 展示关键词列表
                    {
                        username: '张三',
                        email:'111@qq.com',
                        phone:'15200001111',
                        state: '正常',
                        creatTime: '2018-1-29'
                    }
                 ];
                 this.pagerData.page.totalCount = this.pagerData.data.length;   // 重置分页
                  
          
                // } else { 
                  // this.lists = [];   // 清空列表,显示暂无数据
                // }
            //   }
            // )

          }
      },
      handleSubmit (name) {
          this.$refs[name].validate((valid) => {
              if (valid) {
                  this.$Message.success('Success!');
              } else {
                  this.$Message.error('Fail!');
              }
          })
      },
      handleReset (name) {
          this.$refs[name].resetFields();
      },
      addList: function () {
        api.node.create(
          {
            node_type: this.selnodeType,
            num: this.nodeNumber
          },
          resp => {
            api.node.getall({}, resp => {
              this.nodes = resp.info;
            }, error => {
            })
          },
          error => {
          })
      },
      addTry:function(){
         // axios.post('http://localhost:8093/web/sys/user/save',{
         //      "username": this.formLogin.username,
         //      "password": this.formLogin.password,
         //      "captcha": this.formLogin.code,
         //     // "uuid": this.formLogin.uuid
         //    }, {
         //      headers: {
         //        "date": "Wed, 25 Apr 2018 02:58:03 GMT",
         //        "transfer-encoding": "chunked",
         //        "Content-Type": "application/json;charset=UTF-8"
         //      }, transformRequest: [
         //        function (data) {
         //          return Qs.stringify(data);
         //        }],
         //    }).then(
         //      (resp) => {
         //        console.log(resp.data)
         //        console.log(resp.data.code)
         //        if (resp.data.code == 200) {
         //          sessionStorage.setItem('smartkitusername', resp.data.result.username);
         //          sessionStorage.setItem('accesstoken', resp.data.result.token);
         //           // 正确跳转页面
         //          console.log('200');
         //          this.$router.push({ name: 'Index' })
                 
                 
         //          this.$router.replace({ name: 'home' })
         //        } else { 
         //          this.$Message.error('登录失败' + resp.data.code)
         //        }
         //      }
         //    )
      },

      // editNodeok: function () {
      //   api.node.edit({deui: this.selNodetoEdit.deui, node_type: this.selNodetoEdit.type}, resp => {
      //     this.$Message.success('修改成功')
      //   }, error => {
      //   })
      // },

      // editOne: function (index) {
      //   this.selNodetoEdit = this.nodes[index];
      //   this.editNodeModel = true;
      // },
      // show:function (index) {
      //   var item = this.nodes[index];
      //   this.$router.push('NodeInfo?role=admin&deui='+ item.deui)
      // },
      // deleteOne: function (index) {
      //   var item = this.nodes[index];
      //   this.$Modal.confirm({
      //     title: '删除',
      //     content: '确定删除吗',
      //     onOk: () => {
      //       api.node.delete(
      //         {deui: [item.deui]},
      //         resp => {
      //           this.$Message.success('删除成功');
      //           this.nodes.splice(index, 1);
      //         },
      //         error => {})
      //     },
      //     onCancel: () => {
      //     }
      //   });
      // },

      show (index) {
          this.$Modal.info({
              title: 'User Info',
              content: `Name：${this.pagerData.data[index].name}<br>Age：${this.pagerData.data[index].age}<br>Address：${this.pagerData.data[index].address}`
          })
      },
      remove (index) {
          this.pagerData.data.splice(index, 1);
      },
      // 时间转换
      formatDate (date) {
          const y = date.getFullYear();
          let m = date.getMonth() + 1;
          m = m < 10 ? '0' + m : m;
          let d = date.getDate();
          d = d < 10 ? ('0' + d) : d;
          return y + '-' + m + '-' + d;
      },
      // 分页
      onChange:function(curpage){  
          // alert("当前页面页码是：" + curpage);  
          this.pagerData.data.splice(0,this.pagerData.data.length);  
          //alert("当前页面应该显示的数据index是：");  //  10(n-1) ~ 10n  
          for(var i = 10*(curpage - 1) + 1;  
              i<= ((this.pagerData.page.totalCount>10*curpage)?(10*curpage):(this.pagerData.page.totalCount));  
              i++){  
              // console.log(" i = " + i + "，item：" + JSON.stringify(this.listdata[i]));  
              this.pagerData.data.push(this.listdata[i-1]);  
          }  
      }  

  },

    components: {}
  }
</script>



// WEBPACK FOOTER //
// lists.vue?6690a300